/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum OttokartLeadsWorkspaceCapabilityUdoTemplateKey {
    lead = "cf3fb12f-8fb6-4074-93a9-5444a8625b5c",
}
